<template>
    <v-comMain :title="title">
       <div class='gsTitle'>概述</div> 
       <ul class="gsdestion">
           <li>此工具用于帮助开发者检验调用【韵达开放平台开发者API】时发送的请求参数是否正确，提交相关信息后可获得服务器的验证结果。</li>
           <li>1、选择要模拟测试的接口；</li>
           <li>2、点击生成签名按钮，系统会生成该接口的签名密匙；</li>
       </ul>
       <div class="form_title">校验信息</div>
       <p class="titleLine"></p>
       <el-form :model="signForm" size="mini" label-width="160px" class="signForm" :rules="rules" ref="signForm">
           <el-form-item label="API接口名" prop="apiCode">
                <el-select v-model="signForm.apiCode" placeholder="请选择API接口名称" value-key="apiCode" @change="signapiChange">
                <el-option v-for="(item,index) in apiList" :key="index"
                 :label='item.apiName' :value='item'>
                </el-option>
                </el-select>
                <div class="floatBtn" @click="toDetails">查看鉴权说明</div>
           </el-form-item>
           <el-form-item label="APPSecret" prop="appSecret">
                <el-input v-model.trim="signForm.appSecret" placeholder="请输入APPSecret"></el-input>
           </el-form-item>
           <el-form-item label="APPKey" prop="appKey">
                <el-input v-model.trim="signForm.appKey" placeholder="请输入APPKey"></el-input>
           </el-form-item>
           <el-form-item label="目标报文" prop="mockReq">
                <el-input type="textarea" v-model.trim="signForm.mockReq" :autosize="{ minRows: 2, maxRows: 10}"  @blur="mockvalFormat($event)" placeholder="请输入目标报文"></el-input>
           </el-form-item>
           <div class="yd_btn" @click="createSign">生成签名</div>
           <el-form-item label="Header参数">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}"  v-model="headertext" readonly></el-input>    
           </el-form-item>
       </el-form>
    </v-comMain>
</template>
<script>
import controlApi from "@/apis/control";
import comMain from '@/components/comMain.vue';
export default {
    name:'checkSign',
    data() {
        return {
           textarea:'',
           title:'签名校验',
           signForm:{
               apiCode:'',
               appKey:'999999',
               appSecret:'04d4ad40eeec11e9bad2d962f53dda9d',
               mockReq:''
           }, 
           headertext:'',
           apiList:[],
           rules:{
            // apiCode: [
            //     { required: true, message: '请选择API接口名称', trigger: 'change' }
            // ],
            appKey: [
                { required: true, message: '请输入APPKey', trigger: 'blur' },
                {required: true,pattern:/^[A-Za-z0-9]+$/,
			     message: "请输入正确的APPKey",trigger: "blur"}
            ],
            appSecret: [
                { required: true, message: '请输入APPSecret', trigger: 'blur' },
                {required: true,pattern:/^[A-Za-z0-9]+$/,
			     message: "请输入正确的APPSecret",trigger: "blur"}
            ],
            mockReq: [
                { required: true, message: '请输入目标报文', trigger: 'blur' }
            ],
           }
        }
    },
    components:{
        'v-comMain':comMain
    },
    created(){
        this.getApiList();
    },
    methods:{
        //鉴权说明跳转  
        toDetails() {
            const query= {
                apiCode: "apiauth_doc",
                apiName: "API鉴权说明"
            }
            let newpage = this.$router.resolve({
                path: "/api/apiDoc",
                query
            });
            window.open(newpage.href, "_blank");
        },
        //获取api接口名列表
        getApiList(){
           controlApi.getmockapi().then(res=>{
              if(res.success){
                  this.apiList = res.data;
              }
           }) 
        },
        //生成签名
        createSign(){
            this.$refs.signForm.validate((valid) => {
            if (valid) { 
                const Csapicode = this.signForm.apiCode.apiCode;
                // if(!this.isJSON(this.signForm.mockReq)){
                //   this.$message.error('目标报文格式错误!')
                //   return
                // }
                let queryObj =Object.assign({},this.signForm);
                queryObj.apiCode = Csapicode;
                controlApi.generatesign(queryObj).then(res=>{
                    if(res.success){
                        this.$message.success("签名生成成功!")
                        let result = JSON.parse(res.data);
                        const keys = Object.keys(result);
                        const values = Object.values(result);
                        let text = '';
                        for(let i=0;i<keys.length;i++){
                            text +='  "'+keys[i]+'":'+values[i] + '\n'
                        }
                        this.headertext =text;
                    }
                }) 
            } else {
                return false;
            }
            });
        },
        //判断是否为
        isJSON(str) {
            if (typeof str == 'string') {
                console.log(str)
                try {
                    var obj=JSON.parse(str);
                    if(typeof obj == 'object' && obj ){
                        return true;
                    }else{
                        return false;
                    }

                } catch(e) {
                    console.log('error：'+str+'!!!'+e);
                    return false;
                }
            } 
        },
        //编辑文件format
        mockvalFormat(event){
          const val = event.target.value;
          if(this.signForm.mockReq){
            if(this.isJSON(val)){
                this.signForm.mockReq = JSON.stringify(JSON.parse(val));
            }else{
                this.$message.error('目标报文格式错误!')  
            }
          }

        },
        //api接口名选择
        signapiChange(e){
          this.signForm.mockReq = JSON.stringify(JSON.parse(e.mockReq));
        }
    }
}
</script>
<style lang="less" scoped>
.gsTitle{
    font-weight: 500;
    padding: 10px 20px;
    background: #fafafa;    
}   
.gsdestion{
    font-size: 14px;
    padding: 10px 20px;
    line-height: 30px;
}
.form_title{
    font-size: 20px;
    font-weight: bold;
    padding: 20px 20px 4px 20px;
}
.titleLine{
    height: 4px;
    background-color: #e1e4e8;
    margin: 0 20px;
}
.signForm{
    padding-top: 30px;
    margin-right: 50px;
    .yd_btn{
        background: #FABE00;
        width: 120px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        border-radius: 4px;
        margin: 0 0 20px 160px;
        cursor: pointer;
    }
    .floatBtn{
        float: right;
        cursor: pointer;
        color:#409EFF;
    }
    /deep/ textarea{
        min-height: 60px !important;
        resize: none;
        // padding: 0 10px;
    }
}
</style>